<!-- prettier-ignore -->
<div [ngClass]="headerClasses" [ngSwitch]="(combinedModes$ | async)?.promptMode">
  <h2 *ngSwitchCase="'paused'">
    Your subscription is currently Paused. Resume to watch.
  </h2>

  <h2 *ngSwitchCase="'override'">
    {{ promptOverride }}
  </h2>

  <h2 *ngSwitchCase="'default'">
    Unlock this {{ contentType }}, live events, and more with a subscription!
  </h2>
</div>

<div [ngSwitch]="(combinedModes$ | async)?.joinCtaMode">
    <a *ngSwitchCase="'paused'"
      class="btn-primary btn"
      data-test="paused-paywall-button"
      [routerLink]="pausedRoute"
    >
      Resume subscription
    </a>

    <a
      *ngSwitchCase="'override'"
      class="btn-primary btn btn-lg"
      data-test="get-started"
      [routerLink]="joinRoute"
      [queryParams]="{ redirect: redirect }"
    >
      {{ joinButtonTextOverride }}
    </a>

    <a
      *ngSwitchCase="'default'"
      class="btn-primary btn"
      data-test="paywall-button"
      [routerLink]="joinRoute"
      [queryParams]="{ redirect: redirect }"
    >
      Sign Up
    </a>
</div>

<p *ngIf="!loggedIn && !(pausedSubscription$ | async)" class="m-0">
  <span *ngIf="loginButtonTextOverride; else defaultLoginButtonText">{{
    loginButtonTextOverride
  }}</span>
  <ng-template #defaultLoginButtonText>
    <span *ngIf="!loginButtonTextOverride">Already a subscriber?</span>
  </ng-template>
  <a
    id="paywall-login-button"
    data-test="paywall-login"
    [routerLink]="loginRoute"
    [queryParams]="{ redirect: redirect }"
  >
    Log In</a
  >
</p>
